module.exports = __webpack_public_path__ + "img/collection-weddingRingsFacettedConnections@2x.235037c.webp";